import { useEffect, useState } from 'react';
import { pick } from 'lodash';

import { useConstructorContextState } from '../../../context/constructorContext';
import { useGetApiClient } from '../../../context/apiContext/hooks/useGetApiClient';

import { WidgetName } from '../../../models';
import {
  DEFAULT_DIRECTION_DESTINATIONS,
  DEFAULT_SEARCH_DESTINATION,
} from '../../../context/constructorContext/constants';

export const useFetchDestinationIds = () => {
  const [destinationIds, setDestinationIds] = useState<any>(null);
  const api = useGetApiClient();
  const configState = useConstructorContextState();

  const { selectedWidget } = configState;
  const from_city = configState.departure?.value || 'Moscow';

  useEffect(() => {
    const getDestinations = async () => {
      if (!api) {
        console.log('Не найден ключ партнёра');
        return;
      }

      if (
        !selectedWidget ||
        ![WidgetName.DIRECTION, WidgetName.METAREGIONS, WidgetName.SEARCH].includes(selectedWidget)
      ) {
        return;
      }

      const isMetaregionsWidget = selectedWidget === WidgetName.METAREGIONS;
      const isSearchWidget = selectedWidget === WidgetName.SEARCH;

      const widgetNameToDefaultOptions = {
        [WidgetName.SEARCH]: DEFAULT_SEARCH_DESTINATION,
        [WidgetName.DIRECTION]: DEFAULT_DIRECTION_DESTINATIONS,
      };

      const destinationsResponse = await api.referencesPlaces({ from_city });

      const allOptions = destinationsResponse.fullOptions[isMetaregionsWidget ? 0 : 1].options;
      const availableOptions = allOptions?.reduce((result, destination) => {
        if (!destination['closed']) {
          result[destination.label] = destination;
        }

        return result;
      }, {});

      const selectedOptionsObject = !isMetaregionsWidget
        ? pick(availableOptions, widgetNameToDefaultOptions[selectedWidget])
        : availableOptions;
      const selectedOptionsValues = Object.values(selectedOptionsObject);

      setDestinationIds({
        label: 'Направления',
        description: 'Выберите направления',
        active: true,
        options: availableOptions,
        value: isSearchWidget ? selectedOptionsValues[0] : selectedOptionsValues,
      });
    };

    getDestinations().catch((err) => {
      console.error(err);
    });
  }, [from_city, selectedWidget]);

  return { destination_ids: destinationIds };
};
